<template>
  <v-tooltip
    v-if="!$vuetify.display.xs || enableMobile"
    v-model="isTooltipVisible"
    activator="parent"
    :location="location"
    :origin="origin"
    transition="fade-transition"
    :offset="offset"
    open-delay="300"
    close-delay="300"
    :open-on-click="true"
  >
    {{ text }}
  </v-tooltip>
</template>

<script setup lang="ts">
import type { VTooltip } from "vuetify/components"

withDefaults(
  defineProps<{
    text: string
    location?: VTooltip["$props"]["location"]
    origin?: VTooltip["$props"]["origin"]
    offset?: VTooltip["$props"]["offset"]
    enableMobile?: boolean
  }>(),
  {
    text: "",
    location: "top",
    origin: undefined,
    offset: "5px",
    enableMobile: false,
  }
)

const isTooltipVisible = ref(false)

const handleScroll = () => {
  isTooltipVisible.value = false
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
